{
  "validate": "Valider",
  "approved": "Approved"
}
